import { BREAKPOINTS } from "@/settings";
import clsx from "clsx";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  sbcsCount: number;
  solvedCount: number;
};

export const ProgressBar = ({ sbcsCount, solvedCount }: Props) => {
  const isCompleted = solvedCount > 0 && solvedCount === sbcsCount;
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  const progressPercent =
    sbcsCount > 0 ? Math.min((solvedCount / sbcsCount) * 100, 100) : 0;

  return (
    <div
      className={clsx(
        "relative flex items-center w-full ml-[-3px]",
        isMobile ? "" : "w-full",
      )}
      style={{
        height: 20,
        borderRadius: 15,
        background: "rgba(217, 217, 217, 0.05)",
        overflow: "hidden",
      }}
    >
      <span
        className={clsx(
          "text-xs z-10 pl-2",
          isCompleted
            ? "font-semibold text-primary-medium"
            : "text-dark-secondary",
          solvedCount === 0 && "pt-[1px]",
        )}
      >
        {solvedCount}/{sbcsCount} Completed
      </span>
      <div
        className={clsx(
          "absolute",
          isCompleted ? "rounded-[15px]" : "rounded-l-[15px]",
        )}
        style={{
          width: `${progressPercent}%`,
          height: 20,
          background: isCompleted
            ? "#12F26D"
            : "linear-gradient(90deg, #0097D8 71.76%, #00C6CB 98.75%, #5BFBFF 100.08%)",
        }}
      />
    </div>
  );
};
